var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.348 1.507a1.52 1.52 0 0 0-2.154 0L2.543 17.168l-1.318 5.608 5.607-1.318 15.66-15.652h.001a1.52 1.52 0 0 0 0-2.153l-2.145-2.146ZM17.486.8a2.52 2.52 0 0 1 3.568 0L23.2 2.946a2.52 2.52 0 0 1 0 3.567L7.438 22.266a.5.5 0 0 1-.239.133L.668 23.934a.5.5 0 0 1-.602-.601L1.602 16.8a.5.5 0 0 1 .133-.239L17.487.8Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.101 2.415a.48.48 0 0 1 .679 0l4.806 4.805a.48.48 0 0 1-.68.68l-4.805-4.806a.48.48 0 0 1 0-.68Zm-1.373 1.372a.48.48 0 0 1 .679.002l4.796 4.814a.48.48 0 1 1-.68.678l-4.796-4.815a.48.48 0 0 1 .001-.679ZM1.904 16.612a.48.48 0 0 1 .679 0l4.796 4.806a.48.48 0 1 1-.679.678l-4.797-4.805a.48.48 0 0 1 .001-.68Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.9e666f5368b31c629b79b986810994f4.svg";